import { SKELETON_IMAGE_TYPES } from '@constants/skeleton.const'
import './Image.scss'
import { useState } from 'react'
import classNames from 'classnames'
import FallbackImage from '@components/FallbackImage/FallbackImage'

interface ImageProps {
  image: string | undefined
  fallbackOnLoad: boolean
  type?: (typeof SKELETON_IMAGE_TYPES)[number]
  className?: string
  alt?: string
  width?: string
  height?: string
  bgColor?: string
}

export const Image = ({ type, className, image, alt, width, height, fallbackOnLoad, bgColor }: ImageProps) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false)

  const handleIsImageLoaded = () => {
    setIsImageLoaded(true)
  }

  return (
    <div
      className={`image-wrapper ${type || SKELETON_IMAGE_TYPES[2]}`}
      style={{
        ...(bgColor && { backgroundColor: bgColor }),
      }}
    >
      {fallbackOnLoad && !isImageLoaded && <FallbackImage className="on-load" />}
      {image && (
        <img
          className={classNames(className, 'img', { 'img-hidden': !isImageLoaded })}
          src={image}
          alt={alt || 'image'}
          onLoad={handleIsImageLoaded}
          width={width}
          height={height}
        />
      )}
    </div>
  )
}

export default Image
